import React, { useEffect, useState } from "react";
import CryptoPayment from "./crypto-payment";
import MassPay from "./mass-pay";
import { useDispatch, useSelector } from "react-redux";
import { getPayeeData } from "../../../../store/actions";
import { paymentOptions, TRANSFER_MODE } from "../../../../utils/constants";
import OptionSelect from "../common-steps/OptionSelect";
import CommonForm from "./clear-junction";
import AppButton from "../../../../components/AppButton";
import { HomeOutlined } from "@mui/icons-material";
import AppDialogHalfScreen from "../../../../components/AppDialogHalfScreen";
import { Box, Link, Typography } from "@mui/material";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export default function RenderSteps({ type, active,
  amount,
  setActive,
  setShowKyt,
  setShowKytBlocked,
  step }) {
  const [country, setCountry] = useState(null);
  const [currency, setCurrency] = useState(null);
  const bankList = useSelector(({ transfer }) => transfer.connectedBanks);
  const bankFlag = useSelector(({ transfer }) => transfer.connectBank);
  const [isConflict, setIsConflict] = useState(false);
  const [method, setMethod] = useState(type);
  const fiatService = useSelector(({ dashboard }) => dashboard?.fiatService);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  useEffect(() => {
    if(type !== paymentOptions.crypto) {
      setMethod(fiatService?.serviceName)
    } else {
      setMethod(type);
    }
  }, [type, fiatService]);
  useEffect(() => {
    dispatch(getPayeeData());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  if ((bankList?.length === 0 || bankFlag) && active === 2 && type !== paymentOptions.crypto) {
    return (
      <OptionSelect
        active={active}
        setActive={setActive}
        country={country}
        setCountry={setCountry}
        currency={currency}
        setCurrency={setCurrency}
      />
    );
  }
  if(isConflict) {
    return  <AppDialogHalfScreen show={isConflict} setShow={setIsConflict}>
    <Box color={'#F8F8F8'}>

      <Typography variant="subtitle2" fontSize={18} fontWeight={700}>Error</Typography>
      <Typography variant="subtitle2" fontSize={15} textAlign={"left"}>{t('transferFailed')}</Typography>
      <Typography variant="subtitle2"
        data-i18n={`[html]contactAssistance`}
        textAlign={"left"} sx={{ fontSize: "15px" }}>
        <Trans
          components={{
            a: (
              <Link
                href="mailto:support@rocketfuel.inc"
                target="_blank"
                onClick={() => { }}
              />
            ),
          }}
        >
          {t('contactAssistance')}

        </Trans>
      </Typography>

    </Box>
    <AppButton
      sx={{ marginTop: 2 }}
      startIcon={<HomeOutlined />}
      onClick={() => navigate("/home", {
        state: {
          showFeedbackForm: true
        },
      })}
      title={t("BackDashboard")}
    ></AppButton>
  </AppDialogHalfScreen>
  }
  switch (method) {
    case paymentOptions.crypto:
      return <CryptoPayment active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} country={country} currency={currency}/>
    case paymentOptions.masspay:
      return <MassPay active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} country={country} currency={currency}/>;
    case paymentOptions.pockyt:
    case paymentOptions.xbd:
    case paymentOptions.cj:
      return <CommonForm active={active} amount={amount} setActive={setActive} setShowKyt={setShowKyt} setShowKytBlocked={setShowKytBlocked} step={step} mode={TRANSFER_MODE} country={country} currency={currency} setIsConflict={setIsConflict}/>;
      default:
      return <></>
  }
}